module.exports = __webpack_public_path__ + "img/avatar_mero.275ac4ad.png";